/* PLOP_INJECT_EXPORT */
export { Gallery } from './gallery/gallery';
export { Industries } from './industries/industries';
export { SignTypes } from './sign-types/sign-types';
export { Projects } from './projects/projects';
export { Stats } from './stats/stats';
export { FeaturedProjects } from './featured-projects/featured-projects';
export { Testimonial } from './testimonial/testimonial';
export { Steps } from './steps/steps';
export { LatestNews } from './latest-news/latest-news';
export { Slider } from './slider/slider';
export { TextAndMedia } from './text-and-media/text-and-media';
export { Media } from './media/media';
export { Form } from './form/form';
export { Accordion } from './accordion/accordion';
export { HomepageBanner } from './homepage-banner/homepage-banner';
export { PXText } from './text/text'; 
